import { Snackbar, SxProps } from '@mui/material';
import { Theme } from '@emotion/react';

const SnackBar = ({
  show,
  message,
  onClose,
  dir,
  sx,
  autoHideDuration = 3000,
}: {
  show: boolean;
  message: string;
  onClose: (val: any) => void;
  dir?: {
    vertical: 'top' | 'bottom';
    horizontal: 'left' | 'center' | 'right';
  };
  sx?: SxProps<Theme>;
  autoHideDuration?: number;
}) => {
  return (
    <Snackbar
      anchorOrigin={dir ?? { vertical: 'top', horizontal: 'center' }}
      open={show}
      message={message}
      key={'topcenter'}
      sx={{
        '.MuiSnackbarContent-root': {
          backgroundColor: 'rgb(255, 244, 229)',
          height: '3rem',
          color: 'primary.contrastText',
        },
        ...sx,
      }}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
    />
  );
};

export default SnackBar;
